import React, { useState, useEffect } from "react";
import { GetCountries } from "react-country-state-city"; // Import the function

const CountryFlag = ({ countryName }) => {
  const [flagUrl, setFlagUrl] = useState("");

  useEffect(() => {
    if (countryName) {
      GetCountries().then((countries) => {
        const country = countries.find((c) => c.name === countryName); // Find the country by name
        if (country) {
          const flagURL = `https://flagcdn.com/w320/${country.iso2.toLowerCase()}.png`; // Using Flag CDN
          setFlagUrl(flagURL);
        }
      });
    }
  }, [countryName]);

  return (
    <div>
      {flagUrl ? (
        <img src={flagUrl} alt={`Flag of ${countryName}`} className="flag" />
      ) : (
        <p>No flag available</p>
      )}
    </div>
  );
};

export default CountryFlag;
